import { unsupportedNodeAttribute as unsupportedNodeAttributeFactory } from '../../next-schema/generated/markTypes';
export const unsupportedNodeAttribute = unsupportedNodeAttributeFactory({
  toDOM() {
    return ['span'];
  }
});